<template>
  <layout-general v-if="modalVisible === 'delete-box'" @close="modalClose()">
    <h4 class="modal-title" slot="header">{{ $t('general.actions.delete') }} Box</h4>
    <div slot="body">
      <div>
        <h4 class="help-block">{{ $t('modal.delete_box.are_you_sure') }}</h4>
      </div>
    </div>
    <div slot="footer">
      <button @click="boxesDelete()" class="btn btn-danger">
         <span class="txt">{{ $t('modal.delete_box.yes') }}</span>
      </button>
      <button @click="modalClose()" class="btn">
         <span class="txt">{{ $t('general.actions.cancel') }}</span>
      </button>
    </div>
  </layout-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LayoutGeneral from './layout/General.vue';

export default {
  components: {
    LayoutGeneral,
  },
  computed: mapGetters({
    modalVisible: 'modalVisible',
  }),
  methods: mapActions([
    'boxesDelete',
    'modalClose',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** DeleteBox.vue?3e803781
 **/